export default __webpack_public_path__ + "static/media/ensureLiq2.d66d2f14.png";